module.exports = __webpack_public_path__ + "img/students4.950d742d.jpg";